/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportPresenceRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {ReportPresenceResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const reportPresence = (request: ReportPresenceRequest, options?: CashRequestOptions) => post<ReportPresenceRequest, ReportPresenceResponse>("/2.0/cash/report-presence", request, {...options, rejectOnError: true })